// Cities keyed by "COUNTRY_CODE:Province Name"
// Top 10-20 cities per province for key countries (AR, CO, MX),
// top 5-10 for others.
// Only includes countries that have province data in location-data.ts.

export const CITIES: Record<string, string[]> = {
  // ===== ARGENTINA =====
  "AR:Buenos Aires": [
    "La Plata",
    "Mar del Plata",
    "Bahía Blanca",
    "Tandil",
    "Junín",
    "Pergamino",
    "Olavarría",
    "Necochea",
    "Zárate",
    "Campana",
    "Quilmes",
    "Lanús",
    "Avellaneda",
    "Lomas de Zamora",
    "San Isidro",
    "Tigre",
    "Pilar",
    "Morón",
    "Merlo",
    "San Martín",
  ],
  "AR:CABA": ["Buenos Aires"],
  "AR:Catamarca": [
    "San Fernando del Valle de Catamarca",
    "Valle Viejo",
    "Tinogasta",
    "Andalgalá",
    "Belén",
  ],
  "AR:Chaco": [
    "Resistencia",
    "Presidencia Roque Sáenz Peña",
    "Barranqueras",
    "Villa Ángela",
    "Charata",
  ],
  "AR:Chubut": [
    "Rawson",
    "Comodoro Rivadavia",
    "Trelew",
    "Puerto Madryn",
    "Esquel",
  ],
  "AR:Córdoba": [
    "Córdoba",
    "Río Cuarto",
    "Villa María",
    "San Francisco",
    "Villa Carlos Paz",
    "Jesús María",
    "Bell Ville",
    "Río Tercero",
    "Alta Gracia",
    "Marcos Juárez",
  ],
  "AR:Corrientes": [
    "Corrientes",
    "Goya",
    "Paso de los Libres",
    "Curuzú Cuatiá",
    "Mercedes",
  ],
  "AR:Entre Ríos": [
    "Paraná",
    "Concordia",
    "Gualeguaychú",
    "Concepción del Uruguay",
    "Villaguay",
    "Chajarí",
  ],
  "AR:Formosa": ["Formosa", "Clorinda", "Pirané", "El Colorado"],
  "AR:Jujuy": [
    "San Salvador de Jujuy",
    "Palpalá",
    "San Pedro de Jujuy",
    "Libertador General San Martín",
    "Humahuaca",
  ],
  "AR:La Pampa": ["Santa Rosa", "General Pico", "Toay", "General Acha"],
  "AR:La Rioja": ["La Rioja", "Chilecito", "Aimogasta"],
  "AR:Mendoza": [
    "Mendoza",
    "San Rafael",
    "Godoy Cruz",
    "Guaymallén",
    "Las Heras",
    "Maipú",
    "Luján de Cuyo",
    "Tunuyán",
    "San Martín",
  ],
  "AR:Misiones": ["Posadas", "Oberá", "Eldorado", "Puerto Iguazú", "Apóstoles"],
  "AR:Neuquén": [
    "Neuquén",
    "San Martín de los Andes",
    "Centenario",
    "Plottier",
    "Zapala",
    "Cutral Có",
  ],
  "AR:Río Negro": [
    "Viedma",
    "General Roca",
    "Cipolletti",
    "San Carlos de Bariloche",
    "Allen",
  ],
  "AR:Salta": [
    "Salta",
    "San Ramón de la Nueva Orán",
    "Tartagal",
    "General Güemes",
    "Metán",
    "Cafayate",
  ],
  "AR:San Juan": ["San Juan", "Rawson", "Rivadavia", "Chimbas", "Pocito"],
  "AR:San Luis": ["San Luis", "Villa Mercedes", "Merlo", "Justo Daract"],
  "AR:Santa Cruz": [
    "Río Gallegos",
    "Caleta Olivia",
    "El Calafate",
    "Pico Truncado",
  ],
  "AR:Santa Fe": [
    "Santa Fe",
    "Rosario",
    "Rafaela",
    "Reconquista",
    "Venado Tuerto",
    "Villa Gobernador Gálvez",
    "San Lorenzo",
    "Casilda",
    "Esperanza",
    "Sunchales",
  ],
  "AR:Santiago del Estero": [
    "Santiago del Estero",
    "La Banda",
    "Termas de Río Hondo",
    "Añatuya",
    "Frías",
  ],
  "AR:Tierra del Fuego": ["Ushuaia", "Río Grande", "Tolhuin"],
  "AR:Tucumán": [
    "San Miguel de Tucumán",
    "Yerba Buena",
    "Tafí Viejo",
    "Banda del Río Salí",
    "Concepción",
    "Aguilares",
  ],

  // ===== COLOMBIA =====
  "CO:Antioquia": [
    "Medellín",
    "Bello",
    "Itagüí",
    "Envigado",
    "Apartadó",
    "Rionegro",
    "Turbo",
    "Caucasia",
    "Copacabana",
    "La Estrella",
  ],
  "CO:Atlántico": [
    "Barranquilla",
    "Soledad",
    "Malambo",
    "Sabanalarga",
    "Baranoa",
  ],
  "CO:Bogotá D.C.": ["Bogotá"],
  "CO:Bolívar": [
    "Cartagena",
    "Magangué",
    "Turbaco",
    "El Carmen de Bolívar",
    "Arjona",
  ],
  "CO:Boyacá": [
    "Tunja",
    "Duitama",
    "Sogamoso",
    "Chiquinquirá",
    "Puerto Boyacá",
  ],
  "CO:Caldas": ["Manizales", "La Dorada", "Chinchiná", "Villamaría", "Anserma"],
  "CO:Caquetá": ["Florencia", "San Vicente del Caguán"],
  "CO:Casanare": ["Yopal", "Aguazul", "Villanueva"],
  "CO:Cauca": [
    "Popayán",
    "Santander de Quilichao",
    "Puerto Tejada",
    "Piendamó",
  ],
  "CO:Cesar": ["Valledupar", "Aguachica", "Codazzi", "La Jagua de Ibirico"],
  "CO:Córdoba": ["Montería", "Cereté", "Lorica", "Sahagún", "Montelíbano"],
  "CO:Cundinamarca": [
    "Soacha",
    "Facatativá",
    "Zipaquirá",
    "Fusagasugá",
    "Chía",
    "Girardot",
    "Mosquera",
    "Madrid",
  ],
  "CO:Huila": ["Neiva", "Pitalito", "Garzón", "La Plata"],
  "CO:La Guajira": ["Riohacha", "Maicao", "Uribia"],
  "CO:Magdalena": ["Santa Marta", "Ciénaga", "Fundación", "El Banco"],
  "CO:Meta": ["Villavicencio", "Acacías", "Granada"],
  "CO:Nariño": ["Pasto", "Tumaco", "Ipiales", "La Unión"],
  "CO:Norte de Santander": [
    "Cúcuta",
    "Ocaña",
    "Pamplona",
    "Los Patios",
    "Villa del Rosario",
  ],
  "CO:Quindío": ["Armenia", "Calarcá", "La Tebaida", "Montenegro"],
  "CO:Risaralda": [
    "Pereira",
    "Dosquebradas",
    "Santa Rosa de Cabal",
    "La Virginia",
  ],
  "CO:Santander": [
    "Bucaramanga",
    "Floridablanca",
    "Girón",
    "Piedecuesta",
    "Barrancabermeja",
    "San Gil",
  ],
  "CO:Sucre": ["Sincelejo", "Corozal", "San Marcos"],
  "CO:Tolima": ["Ibagué", "Espinal", "Melgar", "Chaparral", "Honda"],
  "CO:Valle del Cauca": [
    "Cali",
    "Buenaventura",
    "Palmira",
    "Tuluá",
    "Buga",
    "Cartago",
    "Yumbo",
    "Jamundí",
  ],

  // ===== MÉXICO =====
  "MX:Aguascalientes": ["Aguascalientes", "Jesús María", "Calvillo"],
  "MX:Baja California": [
    "Tijuana",
    "Mexicali",
    "Ensenada",
    "Rosarito",
    "Tecate",
  ],
  "MX:Baja California Sur": ["La Paz", "Los Cabos", "Comondú"],
  "MX:Campeche": ["Campeche", "Ciudad del Carmen", "Champotón"],
  "MX:Chiapas": [
    "Tuxtla Gutiérrez",
    "Tapachula",
    "San Cristóbal de las Casas",
    "Comitán de Domínguez",
    "Palenque",
  ],
  "MX:Chihuahua": [
    "Chihuahua",
    "Ciudad Juárez",
    "Delicias",
    "Cuauhtémoc",
    "Parral",
  ],
  "MX:Ciudad de México": ["Ciudad de México"],
  "MX:Coahuila": ["Saltillo", "Torreón", "Monclova", "Piedras Negras", "Acuña"],
  "MX:Colima": ["Colima", "Manzanillo", "Tecomán"],
  "MX:Durango": ["Durango", "Gómez Palacio", "Lerdo"],
  "MX:Estado de México": [
    "Toluca",
    "Ecatepec",
    "Naucalpan",
    "Tlalnepantla",
    "Nezahualcóyotl",
    "Atizapán de Zaragoza",
    "Cuautitlán Izcalli",
    "Texcoco",
    "Metepec",
    "Chalco",
  ],
  "MX:Guanajuato": [
    "León",
    "Irapuato",
    "Celaya",
    "Salamanca",
    "Guanajuato",
    "Silao",
    "San Miguel de Allende",
  ],
  "MX:Guerrero": ["Acapulco", "Chilpancingo", "Iguala", "Zihuatanejo", "Taxco"],
  "MX:Hidalgo": ["Pachuca", "Tulancingo", "Tula de Allende", "Huejutla"],
  "MX:Jalisco": [
    "Guadalajara",
    "Zapopan",
    "Tlaquepaque",
    "Tonalá",
    "Puerto Vallarta",
    "Lagos de Moreno",
    "Tepatitlán",
    "Ocotlán",
  ],
  "MX:Michoacán": [
    "Morelia",
    "Uruapan",
    "Lázaro Cárdenas",
    "Zamora",
    "Apatzingán",
  ],
  "MX:Morelos": ["Cuernavaca", "Jiutepec", "Cuautla", "Temixco"],
  "MX:Nayarit": ["Tepic", "Bahía de Banderas", "Santiago Ixcuintla"],
  "MX:Nuevo León": [
    "Monterrey",
    "Guadalupe",
    "San Nicolás de los Garza",
    "Apodaca",
    "Santa Catarina",
    "General Escobedo",
    "San Pedro Garza García",
  ],
  "MX:Oaxaca": [
    "Oaxaca de Juárez",
    "Juchitán de Zaragoza",
    "Salina Cruz",
    "Tuxtepec",
    "Huatulco",
  ],
  "MX:Puebla": [
    "Puebla",
    "Tehuacán",
    "San Martín Texmelucan",
    "Atlixco",
    "Cholula",
  ],
  "MX:Querétaro": [
    "Querétaro",
    "San Juan del Río",
    "El Marqués",
    "Corregidora",
  ],
  "MX:Quintana Roo": [
    "Cancún",
    "Chetumal",
    "Playa del Carmen",
    "Cozumel",
    "Tulum",
  ],
  "MX:San Luis Potosí": [
    "San Luis Potosí",
    "Soledad de Graciano Sánchez",
    "Ciudad Valles",
    "Matehuala",
  ],
  "MX:Sinaloa": ["Culiacán", "Mazatlán", "Los Mochis", "Guasave", "Navolato"],
  "MX:Sonora": [
    "Hermosillo",
    "Ciudad Obregón",
    "Nogales",
    "Guaymas",
    "Navojoa",
  ],
  "MX:Tabasco": ["Villahermosa", "Cárdenas", "Comalcalco", "Macuspana"],
  "MX:Tamaulipas": [
    "Reynosa",
    "Matamoros",
    "Nuevo Laredo",
    "Tampico",
    "Ciudad Victoria",
    "Ciudad Madero",
  ],
  "MX:Tlaxcala": ["Tlaxcala", "Apizaco", "Huamantla"],
  "MX:Veracruz": [
    "Veracruz",
    "Xalapa",
    "Coatzacoalcos",
    "Córdoba",
    "Poza Rica",
    "Orizaba",
    "Minatitlán",
    "Boca del Río",
  ],
  "MX:Yucatán": ["Mérida", "Valladolid", "Tizimín", "Progreso"],
  "MX:Zacatecas": ["Zacatecas", "Fresnillo", "Guadalupe", "Jerez"],

  // ===== CHILE =====
  "CL:Arica y Parinacota": ["Arica"],
  "CL:Tarapacá": ["Iquique", "Alto Hospicio"],
  "CL:Antofagasta": ["Antofagasta", "Calama", "Tocopilla"],
  "CL:Atacama": ["Copiapó", "Vallenar"],
  "CL:Coquimbo": ["La Serena", "Coquimbo", "Ovalle"],
  "CL:Valparaíso": [
    "Valparaíso",
    "Viña del Mar",
    "Quilpué",
    "Villa Alemana",
    "San Antonio",
  ],
  "CL:Metropolitana de Santiago": [
    "Santiago",
    "Puente Alto",
    "Maipú",
    "La Florida",
    "Las Condes",
    "San Bernardo",
    "Peñalolén",
    "Ñuñoa",
  ],
  "CL:O'Higgins": ["Rancagua", "San Fernando", "Rengo"],
  "CL:Maule": ["Talca", "Curicó", "Linares", "Constitución"],
  "CL:Ñuble": ["Chillán", "San Carlos"],
  "CL:Biobío": [
    "Concepción",
    "Talcahuano",
    "Los Ángeles",
    "Chiguayante",
    "Coronel",
  ],
  "CL:Araucanía": ["Temuco", "Padre Las Casas", "Angol", "Villarrica", "Pucón"],
  "CL:Los Ríos": ["Valdivia", "La Unión"],
  "CL:Los Lagos": ["Puerto Montt", "Osorno", "Castro"],
  "CL:Aysén": ["Coyhaique"],
  "CL:Magallanes": ["Punta Arenas", "Puerto Natales"],

  // ===== PERÚ =====
  "PE:Amazonas": ["Chachapoyas", "Bagua"],
  "PE:Áncash": ["Huaraz", "Chimbote", "Nuevo Chimbote"],
  "PE:Apurímac": ["Abancay", "Andahuaylas"],
  "PE:Arequipa": ["Arequipa", "Camaná", "Mollendo"],
  "PE:Ayacucho": ["Ayacucho", "Huanta"],
  "PE:Cajamarca": ["Cajamarca", "Jaén", "Chota"],
  "PE:Callao": ["Callao"],
  "PE:Cusco": ["Cusco", "Sicuani", "Quillabamba"],
  "PE:Huancavelica": ["Huancavelica"],
  "PE:Huánuco": ["Huánuco", "Tingo María"],
  "PE:Ica": ["Ica", "Chincha Alta", "Nazca", "Pisco"],
  "PE:Junín": ["Huancayo", "Tarma", "La Oroya"],
  "PE:La Libertad": ["Trujillo", "Chepén", "Pacasmayo"],
  "PE:Lambayeque": ["Chiclayo", "Lambayeque", "Ferreñafe"],
  "PE:Lima": ["Lima", "Callao", "Huacho", "Cañete"],
  "PE:Loreto": ["Iquitos", "Yurimaguas"],
  "PE:Madre de Dios": ["Puerto Maldonado"],
  "PE:Moquegua": ["Moquegua", "Ilo"],
  "PE:Pasco": ["Cerro de Pasco"],
  "PE:Piura": ["Piura", "Sullana", "Talara", "Paita"],
  "PE:Puno": ["Puno", "Juliaca"],
  "PE:San Martín": ["Tarapoto", "Moyobamba"],
  "PE:Tacna": ["Tacna"],
  "PE:Tumbes": ["Tumbes"],
  "PE:Ucayali": ["Pucallpa"],

  // ===== ECUADOR =====
  "EC:Azuay": ["Cuenca", "Gualaceo"],
  "EC:Bolívar": ["Guaranda"],
  "EC:Cañar": ["Azogues", "La Troncal"],
  "EC:Carchi": ["Tulcán"],
  "EC:Chimborazo": ["Riobamba"],
  "EC:Cotopaxi": ["Latacunga"],
  "EC:El Oro": ["Machala", "Pasaje", "Santa Rosa"],
  "EC:Esmeraldas": ["Esmeraldas", "Atacames"],
  "EC:Galápagos": ["Puerto Ayora"],
  "EC:Guayas": ["Guayaquil", "Durán", "Milagro", "Daule", "Samborondón"],
  "EC:Imbabura": ["Ibarra", "Otavalo"],
  "EC:Loja": ["Loja", "Catamayo"],
  "EC:Los Ríos": ["Babahoyo", "Quevedo"],
  "EC:Manabí": ["Portoviejo", "Manta", "Chone", "Jipijapa"],
  "EC:Morona Santiago": ["Macas"],
  "EC:Napo": ["Tena"],
  "EC:Orellana": ["Francisco de Orellana"],
  "EC:Pastaza": ["Puyo"],
  "EC:Pichincha": ["Quito", "Sangolquí", "Cayambe"],
  "EC:Santa Elena": ["Santa Elena", "Salinas", "La Libertad"],
  "EC:Santo Domingo de los Tsáchilas": ["Santo Domingo"],
  "EC:Sucumbíos": ["Nueva Loja"],
  "EC:Tungurahua": ["Ambato", "Baños"],
  "EC:Zamora Chinchipe": ["Zamora"],

  // ===== URUGUAY =====
  "UY:Artigas": ["Artigas"],
  "UY:Canelones": ["Las Piedras", "Ciudad de la Costa", "Pando", "La Paz"],
  "UY:Cerro Largo": ["Melo"],
  "UY:Colonia": ["Colonia del Sacramento"],
  "UY:Durazno": ["Durazno"],
  "UY:Flores": ["Trinidad"],
  "UY:Florida": ["Florida"],
  "UY:Lavalleja": ["Minas"],
  "UY:Maldonado": ["Maldonado", "Punta del Este", "San Carlos"],
  "UY:Montevideo": ["Montevideo"],
  "UY:Paysandú": ["Paysandú"],
  "UY:Río Negro": ["Fray Bentos"],
  "UY:Rivera": ["Rivera"],
  "UY:Rocha": ["Rocha"],
  "UY:Salto": ["Salto"],
  "UY:San José": ["San José de Mayo"],
  "UY:Soriano": ["Mercedes"],
  "UY:Tacuarembó": ["Tacuarembó"],
  "UY:Treinta y Tres": ["Treinta y Tres"],

  // ===== PARAGUAY =====
  "PY:Alto Paraguay": ["Fuerte Olimpo"],
  "PY:Alto Paraná": ["Ciudad del Este", "Hernandarias", "Presidente Franco"],
  "PY:Amambay": ["Pedro Juan Caballero"],
  "PY:Asunción": ["Asunción"],
  "PY:Boquerón": ["Filadelfia"],
  "PY:Caaguazú": ["Coronel Oviedo", "Caaguazú"],
  "PY:Caazapá": ["Caazapá"],
  "PY:Canindeyú": ["Salto del Guairá", "Curuguaty"],
  "PY:Central": [
    "San Lorenzo",
    "Luque",
    "Fernando de la Mora",
    "Lambaré",
    "Capiatá",
  ],
  "PY:Concepción": ["Concepción"],
  "PY:Cordillera": ["Caacupé"],
  "PY:Guairá": ["Villarrica"],
  "PY:Itapúa": ["Encarnación", "Hohenau"],
  "PY:Misiones": ["San Juan Bautista"],
  "PY:Ñeembucú": ["Pilar"],
  "PY:Paraguarí": ["Paraguarí"],
  "PY:Presidente Hayes": ["Villa Hayes"],
  "PY:San Pedro": ["San Pedro de Ycuamandiyú"],

  // ===== BOLIVIA =====
  "BO:Beni": ["Trinidad", "Riberalta"],
  "BO:Chuquisaca": ["Sucre"],
  "BO:Cochabamba": ["Cochabamba", "Sacaba", "Quillacollo", "Tiquipaya"],
  "BO:La Paz": ["La Paz", "El Alto", "Viacha"],
  "BO:Oruro": ["Oruro"],
  "BO:Pando": ["Cobija"],
  "BO:Potosí": ["Potosí"],
  "BO:Santa Cruz": ["Santa Cruz de la Sierra", "Montero", "Warnes"],
  "BO:Tarija": ["Tarija", "Yacuiba"],

  // ===== VENEZUELA =====
  "VE:Amazonas": ["Puerto Ayacucho"],
  "VE:Anzoátegui": ["Barcelona", "Puerto La Cruz", "El Tigre"],
  "VE:Apure": ["San Fernando de Apure"],
  "VE:Aragua": ["Maracay", "Turmero", "La Victoria"],
  "VE:Barinas": ["Barinas"],
  "VE:Bolívar": ["Ciudad Bolívar", "Ciudad Guayana"],
  "VE:Carabobo": ["Valencia", "Puerto Cabello", "Guacara", "Naguanagua"],
  "VE:Cojedes": ["San Carlos"],
  "VE:Delta Amacuro": ["Tucupita"],
  "VE:Distrito Capital": ["Caracas"],
  "VE:Falcón": ["Coro", "Punto Fijo"],
  "VE:Guárico": ["San Juan de los Morros", "Calabozo", "Valle de la Pascua"],
  "VE:Lara": ["Barquisimeto", "Cabudare", "Carora"],
  "VE:Mérida": ["Mérida", "El Vigía", "Ejido"],
  "VE:Miranda": ["Los Teques", "Guarenas", "Guatire", "Charallave"],
  "VE:Monagas": ["Maturín"],
  "VE:Nueva Esparta": ["Porlamar", "La Asunción"],
  "VE:Portuguesa": ["Acarigua", "Guanare"],
  "VE:Sucre": ["Cumaná", "Carúpano"],
  "VE:Táchira": ["San Cristóbal", "Táriba"],
  "VE:Trujillo": ["Valera", "Trujillo"],
  "VE:Vargas": ["La Guaira", "Catia La Mar"],
  "VE:Yaracuy": ["San Felipe"],
  "VE:Zulia": ["Maracaibo", "Cabimas", "Ciudad Ojeda", "Lagunillas"],

  // ===== BRASIL =====
  "BR:Acre": ["Rio Branco"],
  "BR:Alagoas": ["Maceió", "Arapiraca"],
  "BR:Amapá": ["Macapá"],
  "BR:Amazonas": ["Manaus", "Parintins"],
  "BR:Bahia": [
    "Salvador",
    "Feira de Santana",
    "Vitória da Conquista",
    "Camaçari",
    "Ilhéus",
  ],
  "BR:Ceará": [
    "Fortaleza",
    "Caucaia",
    "Juazeiro do Norte",
    "Maracanaú",
    "Sobral",
  ],
  "BR:Distrito Federal": ["Brasília"],
  "BR:Espírito Santo": ["Vitória", "Vila Velha", "Serra", "Cariacica"],
  "BR:Goiás": ["Goiânia", "Aparecida de Goiânia", "Anápolis"],
  "BR:Maranhão": ["São Luís", "Imperatriz"],
  "BR:Mato Grosso": ["Cuiabá", "Várzea Grande", "Rondonópolis", "Sinop"],
  "BR:Mato Grosso do Sul": ["Campo Grande", "Dourados", "Três Lagoas"],
  "BR:Minas Gerais": [
    "Belo Horizonte",
    "Uberlândia",
    "Contagem",
    "Juiz de Fora",
    "Betim",
    "Montes Claros",
    "Ribeirão das Neves",
    "Uberaba",
  ],
  "BR:Pará": ["Belém", "Ananindeua", "Santarém", "Marabá"],
  "BR:Paraíba": ["João Pessoa", "Campina Grande"],
  "BR:Paraná": [
    "Curitiba",
    "Londrina",
    "Maringá",
    "Ponta Grossa",
    "Cascavel",
    "Foz do Iguaçu",
  ],
  "BR:Pernambuco": [
    "Recife",
    "Jaboatão dos Guararapes",
    "Olinda",
    "Caruaru",
    "Petrolina",
  ],
  "BR:Piauí": ["Teresina", "Parnaíba"],
  "BR:Rio de Janeiro": [
    "Rio de Janeiro",
    "São Gonçalo",
    "Duque de Caxias",
    "Nova Iguaçu",
    "Niterói",
    "Campos dos Goytacazes",
    "Petrópolis",
  ],
  "BR:Rio Grande do Norte": ["Natal", "Mossoró", "Parnamirim"],
  "BR:Rio Grande do Sul": [
    "Porto Alegre",
    "Caxias do Sul",
    "Pelotas",
    "Canoas",
    "Santa Maria",
    "Gravataí",
    "Novo Hamburgo",
  ],
  "BR:Rondônia": ["Porto Velho", "Ji-Paraná"],
  "BR:Roraima": ["Boa Vista"],
  "BR:Santa Catarina": [
    "Florianópolis",
    "Joinville",
    "Blumenau",
    "Chapecó",
    "Itajaí",
    "Criciúma",
  ],
  "BR:São Paulo": [
    "São Paulo",
    "Guarulhos",
    "Campinas",
    "São Bernardo do Campo",
    "Santo André",
    "São José dos Campos",
    "Osasco",
    "Ribeirão Preto",
    "Sorocaba",
    "Santos",
  ],
  "BR:Sergipe": ["Aracaju"],
  "BR:Tocantins": ["Palmas"],

  // ===== ESPAÑA =====
  "ES:Andalucía": [
    "Sevilla",
    "Málaga",
    "Córdoba",
    "Granada",
    "Jerez de la Frontera",
    "Almería",
    "Huelva",
    "Cádiz",
    "Jaén",
    "Marbella",
  ],
  "ES:Aragón": ["Zaragoza", "Huesca", "Teruel"],
  "ES:Asturias": ["Oviedo", "Gijón", "Avilés"],
  "ES:Baleares": ["Palma de Mallorca", "Ibiza", "Manacor"],
  "ES:Canarias": [
    "Las Palmas de Gran Canaria",
    "Santa Cruz de Tenerife",
    "La Laguna",
    "Arrecife",
  ],
  "ES:Cantabria": ["Santander", "Torrelavega"],
  "ES:Castilla y León": [
    "Valladolid",
    "Burgos",
    "Salamanca",
    "León",
    "Palencia",
    "Zamora",
    "Segovia",
    "Ávila",
    "Soria",
  ],
  "ES:Castilla-La Mancha": [
    "Albacete",
    "Toledo",
    "Ciudad Real",
    "Talavera de la Reina",
    "Guadalajara",
    "Cuenca",
  ],
  "ES:Cataluña": [
    "Barcelona",
    "Hospitalet de Llobregat",
    "Badalona",
    "Terrassa",
    "Sabadell",
    "Tarragona",
    "Lleida",
    "Girona",
  ],
  "ES:Comunidad Valenciana": [
    "Valencia",
    "Alicante",
    "Elche",
    "Castellón de la Plana",
    "Torrevieja",
    "Benidorm",
  ],
  "ES:Extremadura": ["Badajoz", "Cáceres", "Mérida", "Plasencia"],
  "ES:Galicia": [
    "Vigo",
    "A Coruña",
    "Ourense",
    "Lugo",
    "Santiago de Compostela",
    "Pontevedra",
  ],
  "ES:La Rioja": ["Logroño", "Calahorra"],
  "ES:Madrid": [
    "Madrid",
    "Móstoles",
    "Alcalá de Henares",
    "Fuenlabrada",
    "Leganés",
    "Getafe",
  ],
  "ES:Murcia": ["Murcia", "Cartagena", "Lorca", "Molina de Segura"],
  "ES:Navarra": ["Pamplona", "Tudela", "Barañáin"],
  "ES:País Vasco": [
    "Bilbao",
    "Vitoria-Gasteiz",
    "San Sebastián",
    "Barakaldo",
    "Getxo",
  ],
}

/**
 * Get cities for a given country code and province/region name.
 * Returns an empty array if no city data exists for that combination.
 */
export function getCitiesForProvince(
  countryCode: string,
  province: string,
): string[] {
  return CITIES[`${countryCode}:${province}`] ?? []
}
